import StoredValue from '../stored-value';

export default new StoredValue('API_TOKEN', '');
